import { promises } from 'fs'
import { ClientGrantApi } from '@wiz-api/eaf-authorization'
import * as R from '../register'
import * as U from '../useLoginInit'
import { routesToMenus } from '../routesToMenus'
import { convertTenantMenusToLayoutWizMenus } from './menu-conversion'

const loadHostModuleMenus = (promiseAll) => {
  const modules = Wiz.dynamicModules.instances
  const withoutAuth = Wiz.globalSettings.layout.config?.withoutAuth
  Object.keys(modules).forEach((moduleName) => {
    const module = modules[moduleName]
    // flag 1-常规模块 2-host管理菜单 4-租户管理员菜单
    if (!_.isUndefined(module.flag) && module.flag === 2) {
      const menus = routesToMenus(module.routes)
      promiseAll.push(R.registerMenus(menus))
      const sysMenus = routesToMenus(module.sysRoutes)
      promiseAll.push(R.registerSysMenus(sysMenus))
    }
    if (withoutAuth && (_.isUndefined(module.flag) || module.flag === 1)) {
      const noAuthMenus = routesToMenus(module.routes)
      promiseAll.push(R.registerMenus(noAuthMenus))
    }
  })
}

const loadDynamicModuleMenus = (promiseAll) => {
  const modules = Wiz.dynamicModules.instances
  Object.keys(modules).forEach((moduleName) => {
    const module = modules[moduleName]
    // flag 1-常规模块 2-host管理菜单 4-租户管理员菜单
    const menus = routesToMenus(module.routes)
    promiseAll.push(R.registerMenus(menus))
  })
}

const disableAllOperations = (ops) => {
  Object.keys(ops).forEach((name) => {
    const op = ops[name]
    op.access = false
  })
}
const mergeOptions = (rOps, mOps) => {
  Object.keys(rOps).forEach((name) => {
    const mAccess =
      mOps.findIndex((item) => {
        return item.name === name
      }) > -1
    rOps[name].access = mAccess
  })
}
const updateRoutesMetaOperations = (menus) => {
  // 通过菜单的operation 更新路由信息 meta.operations
  // 通过path来匹配
  const allRoutes = Wiz.router.getRoutes()
  const pathRoutes = {}
  allRoutes.forEach((r) => {
    pathRoutes[r.path] = r
  })
  // 扁平化
  const indexMenus = {}
  const flatMenu = (ms) => {
    ms.forEach((m) => {
      indexMenus[m.index] = m
      if (m.children) {
        flatMenu(m.children)
      }
    })
  }
  flatMenu(menus)
  // 匹配
  Object.keys(pathRoutes).forEach((p) => {
    const m = indexMenus[p]
    if (m) {
      const r = pathRoutes[p]
      const rOps = r.meta.operations
      if (rOps) {
        disableAllOperations(rOps) // 默认策略
        const mOps = m.meta.operations
        if (mOps) {
          mergeOptions(r.meta.operations, mOps)
        }
      }
    }
  })
}
const loadTenantUserMenus = async (promiseAll) => {
  const clientGrantApi = new ClientGrantApi()
  // clientKey: 租户客户端的客户端唯一标识
  // clientGrantApi.getCurrentUserGrantMenuTree().then(([err, res]) => {
  //   if (!err) {
  //     const layoutMenus = convertTenantMenusToLayoutWizMenus(res)
  //     // todo : change route operations
  //     updateRoutesMetaOperations(layoutMenus)
  //     promiseAll.push(R.registerMenus(layoutMenus))
  //   }
  // })
  const [err, res] = await clientGrantApi.getCurrentUserGrantMenuTree()
  if (!err) {
    const layoutMenus = convertTenantMenusToLayoutWizMenus(res)
    updateRoutesMetaOperations(layoutMenus)
    promiseAll.push(R.registerMenus(layoutMenus))
  }
}
// 更新菜单方法挂载至全局，方面租户菜单更新菜单
// _.assign(Wiz.Hooks, {
//   loadTenantUserMenus,
// })
/** 拦截用户登录，身份发生变化。如果是运营商，直接显示管理模块 */
export default (userInfo) => {
  const oldSetUserInfo = Wiz.AuthHooks.SetUserInfo
  // 运营商登录 自动注册 host-management 菜单，即 flag===0 的模块菜单
  const newSetUserInfo = (u) => {
    oldSetUserInfo(u)
    const tenantid = JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || ''
    console.log('tenantid--set-user', tenantid)
    // 子仓库使用axios未同步token,在这里强制全局更新
    const token = Wiz.AuthHooks.GetToken()
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
    // Wiz.dynamicModules.instances['host-management'].flag
    const modules = Wiz.dynamicModules.instances
    // clearMenus 通常执行比较慢，要在执行完之后在注册
    const promiseAll = []
    if (tenantid === '') {
      loadHostModuleMenus(promiseAll)
    } else if (tenantid.length > 0) {
      loadTenantUserMenus(promiseAll)
    }
  }
  Wiz.AuthHooks.SetUserInfo = newSetUserInfo
}